<!-- <form [formGroup]="form">
<app-searchbar formControlName="search" [placeholder]="'users-list.search-user' | translate"></app-searchbar>
</form> -->

<gbc-tile [title]="'gis-sources-list.title' | translate" style="padding-top: 2em; margin-top: 0">
  @if (gisSources?.length) {
    <gbc-table [clickableRows]="false">
      <th gbc-table-header colspan="2">
        {{ 'gis-sources-list.name' | translate }}
      </th>
      <th gbc-table-header colspan="2">
        {{ 'gis-sources-list.geometry-class' | translate }}
      </th>
      <th gbc-table-header colspan="3">
        {{ 'gis-sources-list.created-by' | translate }}
      </th>
      <th gbc-table-header colspan="2">
        {{ 'gis-sources-list.imported' | translate }}
      </th>
      <th gbc-table-header colspan="3">
        {{ 'gis-sources-list.status' | translate }}
      </th>
      <th gbc-table-header colspan="4">
        {{ 'gis-sources-list.actions' | translate }}
      </th>
      @for (gisSource of gisSources; track gisSource) {
        <tr gbc-table-row>
          <td gbc-table-cell colspan="2">{{ gisSource.description }}</td>
          <td gbc-table-cell colspan="2">
            {{ 'gis-sources-list.geometry-classes.' + gisSource.geometryClass | translate }}
          </td>
          <td gbc-table-cell colspan="3">{{ gisSource.owner }}</td>
          <td gbc-table-cell colspan="2">
            {{ (gisSource.imports | latestGisImportTime) || ('app-never' | translate) }}
          </td>
          <td gbc-table-cell colspan="3">
            @if (
              (gisSource.imports | latestGisImportStatus) === eBatchStatus.Failed && (gisSource.imports | latestGisImport); as latestImport) {
              <ng-container>
                @if ($any(latestImport)?.validationMessages?.length) {
                  <a
                    href="javascript:void(0)"
                    (click)="viewValidationErrors($any(latestImport))"
                    >
                    {{ gisSource.imports | latestGisImportStatus }} </a
                    >
                  } @else {
                    {{ gisSource.imports | latestGisImportStatus }}
                    }<br />
                    <span class="status-message">{{ $any(latestImport)?.statusMessage }}</span>
                    <br />
                    @if (!$any(latestImport)?.validationMessages?.length) {
                      <span class="status-message">
                        {{ '(' + ('gis-sources-list.validation-errors' | translate) + ' N/A)' || '' }}
                      </span>
                    }
                  </ng-container>
                } @else {
                  {{ gisSource.imports | latestGisImportStatus }}
                }
              </td>
              <td gbc-table-cell colspan="4">
                <div class="action-buttons-container">
                  <button [disabled]="gisSource.loading" gbc-button danger class="delete-button" (click)="deleteGisSource(gisSource)">
                    <img class="delete-icon" src="./assets/svgs/trash-can_outline.svg" />
                    {{ 'gis-sources-list.delete' | translate }}
                  </button>
                  <button gbc-button class="import-button" [disabled]="gisSource.loading" (click)="indexGisSource(gisSource)">
                    <img class="delete-icon" src="./assets/svgs/clipboard-replace_outline.svg" />
                    {{ 'gis-sources-list.import' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          }
        </gbc-table>
      } @else {
        <div class="no-sources-label">
          <p>{{ 'gis-sources-list.no-gis-sources' | translate }}</p>
        </div>
      }
    </gbc-tile>
